<template>
  <!--
    La div parte da una posizione nascosta oltre la cima della pagina
    e scende per effetto della trasformazione CSS quando l'alert viene reso visibile
    Poi viene fatta risalire fino a scomparire
  -->

  <div id="b-alert-component" style="position: fixed; top: -50px; padding: 0">
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      style="text-align: center; width: auto"
      variant="warning"
      @dismiss-count-down="countDownChanged"
      >{{ messaggio }}</b-alert
    >
  </div>
</template>

<script>
export default {
  name: "Alert",
  data() {
    return {
      dismissCountDown: 0,
      messaggio: "",
      callback: null,
    };
  },
  props: {},
  watch: {},
  methods: {
    show(messaggio, callback) {
      // Metodo chiamato dall'esterno del componente per visualizzare l'alert
      // Quando dismissCountDown è maggiore di zero, l'alert diventa visibile
      // Viene usato un valore di 6 secondi di cui i primi due servono
      // al messaggio per scendere in posizione, due secondi in cui il messaggio rimane
      // fermo e 2 secondi in cui il messaggio risale oltre il bordo superiore.
      this.messaggio = messaggio;
      this.callback = callback;
      this.dismissCountDown = 5;
      document.getElementById("b-alert-component").style.top = "20px";
    },
    countDownChanged(dismissCountDown) {
      try {
        // Metodo che viene chiamato ogni secondo e che diminuisce il valore di dissmissCountDown
        // Quando questo valore arriva a zero, l'alert diventa invisibile
        this.dismissCountDown = dismissCountDown;
        if (dismissCountDown == 3) {
          document.getElementById("b-alert-component").style.top = "-50px";
        }
        if (dismissCountDown == 1) {
          if (this.callback != null && this.callback != undefined) {
            this.callback();
          }
        }
      } catch (error) {
        this.registraErrore(error, "Alert-countDownChanged");
      }
    },
  },
  mounted() {
    // La posizione dell'alert viene calcolata in modo da posizionarsi sul lato destro della pagina.
    // Il calcolo viene effettuato quando il componente vuiene montato e ogni volta che la pagina
    // è ridimensionata

    let ele = document.getElementById("app");
    let rightAlert =
      ((document.body.clientWidth - ele.offsetWidth + 40) / 2).toString() +
      "px";
    ele = document.getElementById("b-alert-component");
    ele.style.right = rightAlert;

    window.onresize = function () {
      let ele = document.getElementById("app");
      let rightAlert =
        ((document.body.clientWidth - ele.offsetWidth + 40) / 2).toString() +
        "px";
      ele = document.getElementById("b-alert-component");
      ele.style.right = rightAlert;
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<!-- La transizione agisce sul div "alert" quando viene modificata la proprietà top -->
<style scoped>
#b-alert-component {
  transition: top 1s cubic-bezier(0.25, 0.1, 0.25, 1);
  z-index: 9999;
}
</style>
